import React, { useEffect, useState } from "react";
import authBg from "../../images/authBg.jpg";
import fmeLogo from "../../images/fmeLogo.png";
import Loading from "../loadingPage/loading";
import { resources_EN } from "../componentUtils";
import { useNavigate } from "react-router-dom";
import { Path } from "../../RoutesUtils";
import { PostService } from "../../services/genericPostService";
import Swal from "sweetalert2";

const Login = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [isFadingOut, setIsFadingOut] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const navigate = useNavigate();
  useEffect(() => {
    const fadeTimer = setTimeout(() => {
      setIsFadingOut(true);
    }, 2500);

    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 3000);

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(timer);
    };
  }, []);

  if (isLoading) {
    return <Loading isFadingOut={isFadingOut} />;
  }

  /* On Change */
  const onChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  /* Submit */
  const submit = () => {
    const validate = validation();
    if (validate) {
      const data = {
        email: formData.email,
        password: formData.password,
      };
      const url = "/fmeApi/login.php";
      PostService(url, data, modal);
    }
  };

  /* Validation */
  const validation = () => {
    if (formData.email.trim().length < 1) {
      modal(
        resources_EN.error,
        resources_EN.errorTitle,
        resources_EN.emptyEmailValidation
      );
      return false;
    }
    if (formData.password.length < 1) {
      modal(
        resources_EN.error,
        resources_EN.errorTitle,
        resources_EN.emptyPasswordValidation
      );
      return false;
    }

    return true;
  };

  /* Error or Success Modal */
  const modal = (icon, title, message, response = "") => {
    Swal.fire({
      title: title,
      icon: icon,
      text: message,
    }).then((resp) => {
      if (resp.isConfirmed && icon === resources_EN.success) {
        console.log("Responseeee", response);
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("userId", response.data.userData.user_id);
        navigate(Path.home);
      }
    });
  };

  return (
    <div className="2xl:h-screen lg:h-[130vh] flex flex-col lg:flex-row">
      <div className="w-full lg:w-1/2 lg:block hidden">
        <img
          src={authBg}
          alt="Decorative flower"
          className="w-full h-full object-cover"
        />
      </div>

      <div className="w-full lg:w-1/2 p-8 lg:p-12 lg:p-16 flex flex-col justify-center items-center">
        <div className="w-full max-w-md">
          <div className="flex justify-center">
            <img src={fmeLogo} alt="Forglem mig ej logo" className="2xl:w-auto lg:w-44 w-auto" />
          </div>

          <h1 className="text-2xl lg:text-3xl text-center text-green 2xl:my-16 my-12">
            Velkommen til FME
          </h1>

          <form>
            <div className="flex flex-col gap-8">
              <div className="w-full">
                <label htmlFor="email" className="block text-sm font-medium">
                  E-mail
                </label>
                <input
                  type="email"
                  id="email"
                  className="w-full border-b-2 border-gray-300 focus:border-blue-500 focus:outline-none transition duration-300 text-gray-900 text-base py-2"
                  placeholder="Enter your email"
                  value={formData.email}
                  onChange={onChange}
                  name="email"
                />
              </div>
              <div className="w-full">
                <label htmlFor="password" className="block text-sm font-medium">
                  Adgangskode
                </label>
                <input
                  id="password"
                  name="password"
                  type="password"
                  className="w-full border-b-2 border-gray-300 focus:border-blue-500 focus:outline-none transition duration-300 text-gray-900 text-base py-2"
                  placeholder="****************"
                  value={formData.password}
                  onChange={onChange}
                />
              </div>
            </div>

            <div className="flex items-center justify-end mb-8 mt-4">
              <a href={Path.forgotPassword} className="text-md hover:text-black">
                Glemt adgangskode?
              </a>
            </div>

            <div className="flex justify-center 2xl:mb-16 mb-8">
              <button
                type="button"
                className="py-3 px-20 border border-transparent rounded-full text-sm font-medium text-white bg-theme focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-theme cursor-pointer"
                onClick={submit}
              >
                Log ind
              </button>
            </div>

            <div className="text-center">
              <p className="text-md">
                Har du ikke en konto?
                <a href={Path.signUp} className="ml-1 font-bold border-b">
                  Opret konto
                </a>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
